import { ImportLoadsStatus } from '../import-loads-status';
import { ImportTmsLoadResult, ImportTmsLoadStatus, ImportTmsLoadType } from './import-tms-load-result';
import * as moment from 'moment';
import { Moment } from 'moment';

export class ImportTmsLoadsResult {

  public creationSuccesses: ImportTmsLoadResult[] = [];
  public creationFailures: ImportTmsLoadResult[]  = [];

  public updateSuccesses: ImportTmsLoadResult[] = [];
  public updateFailures: ImportTmsLoadResult[]  = [];

  public removalSuccesses: ImportTmsLoadResult[] = [];
  public removalFailures: ImportTmsLoadResult[]  = [];

  public status: ImportLoadsStatus;
  public reason: string;
  public pickMaxDate: Moment;
  public pickMinDate: Moment;
  public importedAt: Moment;

  static fromDto(data: any): ImportTmsLoadsResult {
    if (!data) {
      return null;
    }

    const importResult = new ImportTmsLoadsResult();

    let loadsResults: ImportTmsLoadResult[] = [];

    if (data.results) {
      loadsResults = data.results.map(r => ImportTmsLoadResult.fromDto(r));
    }

    importResult.status      = data.status;
    importResult.reason      = data.reason;
    importResult.pickMaxDate = data.pick_max_date ? moment(data.pick_max_date) : null;
    importResult.pickMinDate = data.pick_min_date ? moment(data.pick_min_date) : null;
    importResult.importedAt  = data.imported_at ? moment(data.imported_at) : null;

    importResult.creationSuccesses = loadsResults
      .filter(r => r.type === ImportTmsLoadType.CREATION)
      .filter(r => r.status === ImportTmsLoadStatus.SUCCEED);
    importResult.creationFailures  = loadsResults
      .filter(r => r.type === ImportTmsLoadType.CREATION)
      .filter(r => r.status === ImportTmsLoadStatus.FAILED);
    importResult.updateSuccesses   = loadsResults
      .filter(r => r.type === ImportTmsLoadType.UPDATE)
      .filter(r => r.status === ImportTmsLoadStatus.SUCCEED);
    importResult.updateFailures    = loadsResults
      .filter(r => r.type === ImportTmsLoadType.UPDATE)
      .filter(r => r.status === ImportTmsLoadStatus.FAILED);
    importResult.removalSuccesses  = loadsResults
      .filter(r => r.type === ImportTmsLoadType.REMOVAL)
      .filter(r => r.status === ImportTmsLoadStatus.SUCCEED);
    importResult.removalFailures   = loadsResults
      .filter(r => r.type === ImportTmsLoadType.REMOVAL)
      .filter(r => r.status === ImportTmsLoadStatus.FAILED);

    return importResult;
  }
}

export enum ImportTmsLoadsResultReason {
  BLUJAY_CREDENTIALS_ERROR = 'BLUJAY_CREDENTIALS_ERROR'
}
